import React from 'react'

import { Grid, TextField } from '@material-ui/core'
import telephone from '@scoir/components-core/dist/components/telephone'
import update from '@scoir/immutability'
import { isEmpty, trim } from 'lodash'
import PropTypes from 'prop-types'

import './Edit.scss'

export default class Edit extends React.Component {
  static propTypes = {
    editUser: PropTypes.object.isRequired,
    onUpdate: PropTypes.func.isRequired,
    showDisabledEmail: PropTypes.bool,
  }
  static defaultProps = {
    showDisabledEmail: false,
  }
  constructor(props) {
    super(props)
    this.state = {
      isExtValid: true,
      isPhoneValid: true,
      isCellValid: true,
      isFirstNameValid: true,
      isLastNameValid: true,
    }
  }
  updateField(field, value) {
    const editUser = update(this.props.editUser, { [field]: { $set: value } })
    const isValid = this.isValid()
    this.props.onUpdate(editUser, isValid, field, value)
  }
  updateRequiredField(field, value) {
    this.setState(
      {
        [`is${field}Valid`]: !isEmpty(value),
      },
      () => {
        this.updateField(field, value)
      },
    )
  }
  isValid() {
    return (
      this.state.isPhoneValid &&
      this.state.isCellValid &&
      this.state.isExtValid &&
      this.state.isFirstNameValid &&
      this.state.isLastNameValid
    )
  }
  isValidAndUpdate() {
    this.props.onUpdate(this.props.editUser, this.isValid())
  }
  render() {
    const { editUser, showDisabledEmail } = this.props
    return (
      <div className="edit-my-profile-comp">
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={4}
          >
            <TextField
              id="edit-profile-first-name"
              variant="outlined"
              fullWidth
              error={!this.state.isFirstNameValid}
              value={editUser.FirstName}
              onChange={(e) => this.updateRequiredField('FirstName', e.target.value)}
              onBlur={(e) => this.updateRequiredField('FirstName', trim(e.target.value))}
              label="First Name"
            />
          </Grid>
          <Grid
            item
            xs={4}
          >
            <TextField
              id="edit-profile-middle-name"
              variant="outlined"
              fullWidth
              value={editUser.MiddleName}
              onChange={(e) => this.updateField('MiddleName', e.target.value)}
              onBlur={(e) => this.updateField('MiddleName', trim(e.target.value))}
              label="Middle Name"
            />
          </Grid>
          <Grid
            item
            xs={4}
          >
            <TextField
              id="edit-profile-last-name"
              variant="outlined"
              fullWidth
              error={!this.state.isLastNameValid}
              value={editUser.LastName}
              onChange={(e) => this.updateRequiredField('LastName', e.target.value)}
              onBlur={(e) => this.updateRequiredField('LastName', trim(e.target.value))}
              label="Last Name"
            />
          </Grid>
          <Grid
            item
            xs={12}
          >
            <TextField
              id="edit-profile-title"
              variant="outlined"
              fullWidth
              value={editUser.Title}
              onChange={(e) => this.updateField('Title', e.target.value)}
              label="Title"
            />
          </Grid>
          {showDisabledEmail && (
            <Grid
              item
              xs={12}
            >
              <TextField
                id="edit-profile-email"
                variant="outlined"
                fullWidth
                type="email"
                value={editUser.Email}
                disabled
                label="Email"
              />
            </Grid>
          )}
          <Grid
            item
            xs={8}
          >
            <TextField
              id="edit-profile-work-phone"
              variant="outlined"
              fullWidth
              value={telephone.format(editUser.Phone)}
              error={!this.state.isPhoneValid}
              onChange={(e) => {
                const val = telephone.unformat(e.target.value)
                const isPhoneValid = !val || (val.length >= 10 && val.length <= 13)
                this.updateField('Phone', val)
                this.setState({ isPhoneValid }, () => this.isValidAndUpdate())
              }}
              label="Work Phone"
            />
          </Grid>
          <Grid
            item
            xs={4}
          >
            <TextField
              id="edit-profile-work-phone-ext"
              variant="outlined"
              fullWidth
              pattern="[0-9]*"
              inputProps={{
                maxLength: 5,
              }}
              error={!this.state.isExtValid}
              value={editUser.PhoneExtension}
              onChange={(e) => this.updateField('PhoneExtension', e.target.value)}
              label="Ext"
            />
          </Grid>
          <Grid
            item
            xs={8}
          >
            <TextField
              id="edit-profile-work-phone"
              variant="outlined"
              fullWidth
              value={telephone.format(editUser.CellPhone)}
              error={!this.state.isCellValid}
              onChange={(e) => {
                const val = telephone.unformat(e.target.value)
                const isCellValid = !val || (val.length >= 10 && val.length <= 13)
                this.updateField('CellPhone', val)
                this.setState({ isCellValid }, () => this.isValidAndUpdate())
              }}
              label="Cell Phone"
            />
          </Grid>
        </Grid>
      </div>
    )
  }
}
